import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Message } from '@app/core/message/models/message.model'

@Component({
    selector: 'aio-message-dialog',
    templateUrl: './message-dialog.component.html',
    styleUrls: ['./message-dialog.component.sass'],
    standalone: false
})
export class MessageDialogComponent {
  // eslint-disable-next-line no-useless-constructor
  constructor(
    public dialogRef: MatDialogRef<MessageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { message: Message; header: string }
  ) {}
}
